import Glide from "@glidejs/glide"

const selector                  = '[data-gallery]';
const slidesSelector            = '[data-gallery-slides]';
const paginationCurrentSelector = '[data-pagination-current]';
const paginationTotalSelector   = '[data-pagination-total]';
const initClass                 = 'gallery--ready';

let els = null;

function Gallery() {

	// Search for carousel elements on page
	els = document.querySelectorAll(selector);
	
	// If there are any, continue
	if (els.length) {
		init();
	}
}

const init = () => {

	// Check for pagination on each gallery
	[].forEach.call(els, function(item) {

		const g = new Glide(selector, {
			type: 'carousel',
			perView: 1,
			gap: 0
		});
		g.on("run.before", (e) => {
			handleSlideChanged(e, item);
		});
		g.on("mount.after", () => {
			handleGalleryMounted(item);
		});
		
		if (item.querySelector('[data-pagination]') !== null) {
			initPagination(item);
		}

		g.mount()

	});
}

// Handles when slide changed
const handleSlideChanged = (e, el) => {
	
	const currEl   = el.querySelector(paginationCurrentSelector);
	const totalEl  = el.querySelector(paginationTotalSelector);
	const totalNum = totalEl.innerHTML * 1;

	let currNum  = currEl.innerHTML * 1;

	// Increase/decrease curr number based on direction
	switch (e.direction) {

		case "<":
			currNum--;
			break;
		case ">":
			currNum++;

	}

	// Make sure number doesn't exceed limits
	if (currNum <= 0) {
		currNum = totalNum;
	}
	if (currNum > totalNum) {
		currNum = 1;
	}

	currEl.innerHTML = currNum;
}

// Handles when gallery has been mounted
const handleGalleryMounted = (el) => {

	// Add class to gallery to show it's ready
	el.classList.add(initClass);
}

const initPagination = (el) => {

	const currEl  = el.querySelector(paginationCurrentSelector);
	const totalEl = el.querySelector(paginationTotalSelector);

	totalEl.innerHTML = el.querySelector(slidesSelector).children.length;
}

export default Gallery;